import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../_metronic/_partials/controls";
import Table, {
  dateFormatter,
  buttonsStyle,
} from "../../../components/tables/table";
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";
import { getCountries, deleteCountry, changeStatusCountry } from "../../../../api/country";
import { Button, Tooltip } from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import { alertError, alertSuccess } from "../../../../utils/logger";
import { useHistory } from "react-router-dom";
import ToggleOffIcon from "@material-ui/icons/ToggleOff";
import ToggleOnIcon from "@material-ui/icons/ToggleOn";
import { shallowEqual, useSelector } from "react-redux";

function getData(countries) {
  return countries.map(country => ({
    name: country.name,
    code: country.code,
    prefix: country.prefix,
    createdAt: country.createdAt,
    id: country._id,
    active: country.active
  }));
}

export default function CountryPage() {
  const history = useHistory();
  const user = useSelector((store) => store.authentication?.user, shallowEqual);

  const [openConfirmDialog, setOpenConfirmDialog] = useState(null);
  const [refresh, setRefresh] = useState(false);
  const [data, setData] = useState([]);
  const [country, setCountry] = useState(null);


  function buttonFormatter(cell) {
    const elem = data.find((item) => item.id === cell);
    return (
      <>
        <Tooltip title="Editar">
          <Button
            style={buttonsStyle}
            size="small"
            onClick={() => history.push("/edit-country/" + elem.id)}
          >
            <EditIcon />
          </Button>
        </Tooltip>
        {user?.isAdmin && (
          <>
            <Tooltip title={elem?.active ? "Desactivar" : "Activar"}>
              <Button
                style={buttonsStyle}
                size="small"
                onClick={() => {
                  setCountry(elem);
                  setOpenConfirmDialog(1);
                }}
              >
                {elem?.active ? (
                  <ToggleOffIcon />
                ) : (
                  <ToggleOnIcon style={{ color: "red" }} />
                )}
              </Button>
            </Tooltip>
            <Tooltip title="Borrar">
              <Button
                style={buttonsStyle}
                size="small"
                onClick={() => {
                  setCountry(elem);
                  setOpenConfirmDialog(2);
                }}
              >
                <DeleteIcon />
              </Button>
            </Tooltip>
          </>
        )}
      </>
    );
  }

  const columns = [
    { dataField: "name", text: "Nombre", sort: true },
    { dataField: "code", text: "Código ISO", sort: true },
    { dataField: "prefix", text: "Prefijo", sort: true },
    {
      dataField: "createdAt",
      text: "Fecha de creación",
      formatter: dateFormatter,
      sort: true,
    },
    {
      dataField: "id",
      text: "",
      formatter: buttonFormatter,
      headerStyle: { width: '200px' }
    },
  ];

  useEffect(() => {
    getCountries()
      .then((res) => {
        setData(getData(res.data));
      })
      .catch((error) => {
        alertError({ error: error, customMessage: "No se han podido obtener los países." });
      });
  }, [refresh]);

  return (
    <>
      <Card>
        <CardHeader title="Países">
          <CardHeaderToolbar>
            <button
              type="button"
              className="btn btn-primary text-white"
              onClick={() => history.push("/edit-country")}
            >
              Añadir
            </button>
          </CardHeaderToolbar>
        </CardHeader>
        <CardBody>
          <Table search={true} data={data} columns={columns} />


          <ConfirmDialog
            title={`Seguro que quieres ${country?.active ? "desactivar" : "activar"} este país?`}
            open={openConfirmDialog === 1}
            setOpen={setOpenConfirmDialog}
            onConfirm={() => {
              changeStatusCountry(country.id, !country?.active)
                .then((res) => {
                  alertSuccess({
                    title: `${country?.active ? "Desactivar!" : "Activar!"
                      }`,
                    customMessage: `País ${country?.active ? "desactivado" : "activado"
                      } correctamente`,
                  });
                  setRefresh(true);
                })
                .catch((error) => {
                  alertError({
                    error: error,
                    customMessage: `No se ha podido ${country?.active ? "desactivar" : "activar"
                      } el país.`,
                  });
                });
            }}
          />
          <ConfirmDialog
            title={"Seguro que quieres eliminar este país?"}
            open={openConfirmDialog === 2}
            setOpen={setOpenConfirmDialog}
            onConfirm={() => {
              deleteCountry(country.id)
                .then((res) => {
                  alertSuccess({
                    title: "Eliminado!",
                    customMessage: "Country deleted correctamente.",
                  });
                  setRefresh(true);
                })
                .catch((error) => {
                  alertError({
                    error: error,
                    customMessage: "No se ha podido eliminar el país.",
                  });
                });
            }}
          />
        </CardBody>
      </Card>
    </>
  );
}
